export function StarRating({ rating, size = 14, showNumber = false, reviewCount }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
      <div className="stars">
        {[1, 2, 3, 4, 5].map(i => (
          <svg key={i} width={size} height={size} viewBox="0 0 16 16">
            <polygon
              points="8,1 10,6 15,6.5 11.5,10 12.5,15 8,12.5 3.5,15 4.5,10 1,6.5 6,6"
              fill={i <= Math.round(rating) ? '#C9972A' : '#E9ECEF'}
            />
          </svg>
        ))}
      </div>
      {showNumber && (
        <span style={{ fontSize: size, fontWeight: 500, color: '#343A40' }}>{rating.toFixed(1)}</span>
      )}
      {reviewCount !== undefined && (
        <span style={{ fontSize: size - 1, color: '#6C757D' }}>({reviewCount})</span>
      )}
    </div>
  );
}

export function StarPicker({ value, onChange }) {
  return (
    <div style={{ display: 'flex', gap: 6 }}>
      {[1, 2, 3, 4, 5].map(i => (
        <button key={i} type="button" onClick={() => onChange(i)} style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer' }}>
          <svg width={32} height={32} viewBox="0 0 16 16">
            <polygon
              points="8,1 10,6 15,6.5 11.5,10 12.5,15 8,12.5 3.5,15 4.5,10 1,6.5 6,6"
              fill={i <= value ? '#C9972A' : '#E9ECEF'}
              style={{ transition: 'fill 0.1s' }}
            />
          </svg>
        </button>
      ))}
    </div>
  );
}
